import Link from "react";

function Footer(props) {
  return;
  <h1>mfaisal718@gmail.com</h1>;
  <h3>https://www.linkedin.com/in/mohammed-faisal-nyc/</h3>;
}

export default Footer;
